<form *ngIf="!(isLoading$ | async)" [formGroup]="selectBoxForm" novalidate>
  <rk-modal-wrapper
    (submitted)="onSubmit()"
    (cancelled)="onCancel()"
    (closed)="onCancel()"
    [title]="'MEDIA.MODAL.PLAYLIST.UPLOAD.TITLE' | translate"
    [submitText]="'MEDIA.MODAL.PLAYLIST.UPLOAD.ACTION_BUTTON' | translate"
    [hideCancelOnLoading]="true"
  >
    <div class="content-upload-track" translate>MEDIA.MODAL.PLAYLIST.UPLOAD.CONTENT</div>
    <div class="bac-container">
      <rk-dropdown-autocomplete
        [modal]="true"
        formControlName="targetBac"
        [data]="$boxes()"
      ></rk-dropdown-autocomplete>
    </div>
  </rk-modal-wrapper>
</form>

<input
  #trackUploadFileInput
  type="file"
  [accept]="accept"
  [multiple]="true"
  (change)="onFileSelect($event)"
  class="input-file"
/>
